<script setup lang="ts">
import { useId } from "vue";

withDefaults(
  defineProps<{
    checked: boolean;
    /** `neutral`: charcoal track when on (schedule-style). Default orange (design). */
    tone?: "brand" | "neutral";
  }>(),
  { tone: "brand" },
);

const emit = defineEmits<{
  toggle: [];
}>();

const switchId = useId();

function onNativeChange(): void {
  emit("toggle");
}
</script>

<template>
  <!-- Structure adapted from Uiverse.io by zanina-yassine (checkbox + track + thumb) -->
  <div
    class="popup-design-switch__shell"
    :class="{ 'popup-design-switch__shell--neutral': tone === 'neutral' }"
  >
    <input
      :id="switchId"
      type="checkbox"
      class="popup-design-switch__native"
      :checked="checked"
      @change="onNativeChange"
    />
    <label class="popup-design-switch__track" :for="switchId">
      <span class="popup-design-switch__thumb" aria-hidden="true" />
    </label>
  </div>
</template>

<style scoped>
/* From Uiverse.io by zanina-yassine — scoped + BEM class names for this component */

.popup-design-switch__shell {
  width: 44px;
  height: 26px;
  position: relative;
  flex-shrink: 0;
  vertical-align: middle;
}

.popup-design-switch__native {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.popup-design-switch__track {
  width: 100%;
  height: 100%;
  display: block;
  background-color: #e9e9eb;
  border-radius: 13px;
  cursor: pointer;
  transition: all 0.2s ease-out;
}

.popup-design-switch__thumb {
  width: 22px;
  height: 22px;
  position: absolute;
  left: calc(50% - 22px / 2 - 8px);
  top: calc(50% - 22px / 2);
  border-radius: 50%;
  background: #ffffff;
  box-shadow:
    0px 2px 6px rgba(0, 0, 0, 0.14),
    0px 2px 1px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease-out;
  cursor: pointer;
  pointer-events: none;
}

.popup-design-switch__native:checked + .popup-design-switch__track {
  background-color: #e87e26;
}

.popup-design-switch__native:checked
  + .popup-design-switch__track
  .popup-design-switch__thumb {
  left: calc(50% - 22px / 2 + 8px);
  top: calc(50% - 22px / 2);
}

.popup-design-switch__native:focus {
  outline: none;
}

.popup-design-switch__native:focus-visible + .popup-design-switch__track {
  outline: 2px solid #e87e26;
  outline-offset: 2px;
}

.popup-design-switch__shell--neutral
  .popup-design-switch__native:checked
  + .popup-design-switch__track {
  background-color: #3b3b3e;
}

.popup-design-switch__shell--neutral
  .popup-design-switch__native:focus-visible
  + .popup-design-switch__track {
  outline: 2px solid #6a6a6f;
  outline-offset: 2px;
}
</style>
